import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, Input, OnInit, OnDestroy } from '@angular/core';
import { NgbAccordionModule, NgbCarouselModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgScrollbarModule } from 'ngx-scrollbar';
import {AuthService} from "../../_services/auth.service";
import { GlobalFilterService, GlobalFilter } from '../../_services/global-filter.service';
import { ReportingEntityService } from '../../_services/reporting-entity.service';
import { PermissionService } from '../../_services/permission.service';
import { ReportingEntity } from '../../_models/reporting-entity.model';
import { Subscription } from 'rxjs';

interface NavNotification {
  btn: string;
  icon: string;
  title: string;
  subject: string;
  time: string;
}

interface NavMessage {
  useravatar: string;
  status: string;
  from: string;
  subject: string;
  time: string;
}

interface Language {
  language: string;
  code: string;
  type?: string;
  icon: string;
}

@Component({
  selector: 'app-vertical-navigation',
  standalone: true,
  imports: [
    NgbAccordionModule,
    NgScrollbarModule,
    NgbCarouselModule,
    NgbDropdownModule,
    CommonModule
  ],
  templateUrl: './vertical-navigation.component.html',
  styleUrls: ['./vertical-navigation.component.css']
})
export class VerticalNavigationComponent implements OnInit, OnDestroy {
  @Input() sidebarExpanded: boolean = true;
  @Output() toggleSidebar = new EventEmitter<void>();

  public showSearch = false;

  // Global filter state
  canUseGlobalFilter = false;
  globalFilter: GlobalFilter | null = null;
  reportingEntities: ReportingEntity[] = [];
  private globalFilterSub?: Subscription;
  private permissionsSub?: Subscription;

  // This is for Notifications
  notifications: NavNotification[] = [
    {
      btn: 'btn-danger',
      icon: 'ti-link',
      title: 'Luanch Admin',
      subject: 'Just see the my new admin!',
      time: '9:30 AM',
    },
    {
      btn: 'btn-success',
      icon: 'ti-calendar',
      title: 'Event today',
      subject: 'Just a reminder that you have event',
      time: '9:10 AM',
    },
    {
      btn: 'btn-info',
      icon: 'ti-settings',
      title: 'Settings',
      subject: 'You can customize this template as you want',
      time: '9:08 AM',
    },
    {
      btn: 'btn-primary',
      icon: 'ti-user',
      title: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM',
    },
  ];

  // This is for Mymessages
  mymessages: NavMessage[] = [
    {
      useravatar: 'assets/images/users/user1.jpg',
      status: 'online',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:30 AM',
    },
    {
      useravatar: 'assets/images/users/user2.jpg',
      status: 'busy',
      from: 'Sonu Nigam',
      subject: 'I have sung a song! See you at',
      time: '9:10 AM',
    },
    {
      useravatar: 'assets/images/users/user2.jpg',
      status: 'away',
      from: 'Arijit Sinh',
      subject: 'I am a singer!',
      time: '9:08 AM',
    },
    {
      useravatar: 'assets/images/users/user4.jpg',
      status: 'offline',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM',
    },
  ];

  public selectedLanguage: Language = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: 'us',
  };

  public languages: Language[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: 'us',
    },
    {
      language: 'Español',
      code: 'es',
      icon: 'es',
    },
    {
      language: 'Français',
      code: 'fr',
      icon: 'fr',
    },
    {
      language: 'German',
      code: 'de',
      icon: 'de',
    },
  ];

  constructor(
    private translate: TranslateService,
    private authService: AuthService,
    private globalFilterService: GlobalFilterService,
    private reportingEntityService: ReportingEntityService,
    private permissionService: PermissionService,
  ) {
    translate.setDefaultLang('en');
  }

  ngOnInit(): void {
    this.globalFilterSub = this.globalFilterService.globalFilter$.subscribe(filter => {
      this.globalFilter = filter;
    });

    this.evaluateGlobalFilterAccess();

    this.permissionsSub = this.permissionService.getPermissionsLoadedObservable().subscribe(loaded => {
      if (loaded) {
        this.evaluateGlobalFilterAccess();
      }
    });
  }

  ngOnDestroy(): void {
    this.globalFilterSub?.unsubscribe();
    this.permissionsSub?.unsubscribe();
  }

  private evaluateGlobalFilterAccess(): void {
    this.canUseGlobalFilter = this.globalFilterService.canUseGlobalFilter();

    if (this.canUseGlobalFilter) {
      this.reportingEntityService.getReportingEntities(1, 100, { includeDivisions: true }).subscribe({
        next: (response) => {
          this.reportingEntities = response.entities;
        },
        error: (error) => {
          console.error('Error loading reporting entities for global filter', error);
        }
      });
    } else {
      this.reportingEntities = [];
    }
  }

  changeLanguage(lang: Language) {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
  }

  logout(){
    this.authService.logout();
  }
  
  isDevUser(): boolean {
    return this.authService.hasRole('dev');
  }
  
  getCurrentUser() {
    return this.authService.getCurrentUser();
  }

  selectGlobalReportingEntity(re: ReportingEntity): void {
    this.globalFilterService.setGlobalFilter(re);
  }

  clearGlobalFilter(): void {
    this.globalFilterService.clearGlobalFilter();
  }
}
